import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { startSession } from '../lib/session';
import SessionRecovery from '../components/SessionRecovery';
export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, user, error } = useAuth0();
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (isLoading || error || !isAuthenticated || !user?.sub) return;
    let active = true;
    setFailed(false);
    void startSession(user.sub)
      .then(({ claimed }) => {
        if (active) navigate(claimed ? '/history' : '/scan', { replace: true });
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [isAuthenticated, isLoading, user?.sub, error, navigate]);
  if (error || (!isLoading && !isAuthenticated))
    return (
      <main className="app-main">
        <h1>{t('trial.authCancelled')}</h1>
        <p>{t('trial.cancelledBody')}</p>
        <Link to="/scan">{t('trial.returnToWork')}</Link>
      </main>
    );
  if (failed) return <SessionRecovery />;
  return <SessionRecovery loading />;
}
